<div class="skill-search-input" [class.gray-bg]="grayBg">

  <div class="skill-search-input__inner" [class.has-error]="control.invalid && isSubmitted">
    <div class="skill-search-input__items-bg" *ngIf="showItems" (click)="showDropdown(false)"></div>
    <div class="skill-search-input__items" @slideInOut
      *ngIf="showItems" 
      [class.open-top]="openPositionTop">
      <div class="skill-search-input__items-inner is-scroll" #scrolledEl>
        <ng-container *ngFor="let branch of allItems">
          <div class="skill-search-input__item"
            *ngFor="let skill of branch.skills; let i = index;" 
            [id]="'a-select-item-id-' + i"
            [class.active]="skill.selected"
            (click)="selectSkill({ id: branch.id, name: branch.name }, skill, skill.selected)">
            {{ skill.name }}
          </div>
        </ng-container>
        <div class="skill-search-input__no-found" *ngIf="allItems && !allItems.length">
          Nothing found
        </div>
        <div class="skill-search-input__no-found" *ngIf="!allItems">
          Start type to search
        </div>
      </div>
    </div>

    <div class="skill-search-input__input-box">
      <input #selectEl
        placeholder=" "
        [formControl]="control"
        (focus)="onFocus(true)" 
        (blur)="onFocus(false)">
      <label>{{ label }}</label>
      <i class="app-ico-mask app-ico-mask__search"></i>
      <!-- <i class="app-ico-mask app-ico-mask__x" *ngIf="control.value" (click)="clear()"></i> -->
      <!-- <i class="app-ico-mask app-ico-mask__select-arrow-down" 
        [class.is-open]="showItems"
        (click)="showDropdown(showItems ? false : true)">
      </i> -->
    </div>
  </div>

</div>